import { useState } from "react";

// Prefixe de deploiement (prod : /app derriere nginx, dev : racine)
export const BASE_PATH = process.env.REACT_APP_BASE_PATH || "";

export const languages = [
  { locale: "en", name: "English" },
  { locale: "es", name: "Español" },
  { locale: "ar", name: "العربية" },
  { locale: "fr", name: "Français" },
  { locale: "zh", name: "简体中文" },
  { locale: "ru", name: "русский" },
  { locale: "tr", name: "Türkçe" },
  { locale: "id", name: "Bahasa Indonesia" },
  { locale: "vi", name: "Tiếng Việt" },
];

export const locales = languages.map((language) => {
  return language.locale;
});

export const useLocationLocale = () => {
  return locales.find((locale) => {
    // Segment entier : "/app/fr" ne doit pas matcher "/app/free-numbers"
    return (
      window.location.pathname === `${BASE_PATH}/${locale}` ||
      window.location.pathname.startsWith(`${BASE_PATH}/${locale}/`)
    );
  });
};

export const useLocalStorageLocale = () => {
  return locales.find((locale) => {
    return locale === localStorage.getItem("i18nextLng");
  });
};

export const useLocale = () => {
  const locationLocale = useLocationLocale();
  const localStorageLocale = useLocalStorageLocale();

  const [locale] = useState(() => {
    return locationLocale || localStorageLocale || "en";
  });

  return { locale };
};

export const useBasename = () => {
  const { locale } = useLocale();
  const basename = `${BASE_PATH}/${locale || ""}`;

  // Meme regle de segment entier pour savoir si l'URL est deja prefixee
  if (
    window.location.pathname !== basename &&
    !window.location.pathname.startsWith(`${basename}/`)
  ) {
    const rest = window.location.pathname.replace(BASE_PATH, "");
    window.location.replace(
      basename + (rest !== "/" ? rest : "") + window.location.search + window.location.hash
    );
  }

  return { basename };
};

export const useLanguage = () => {
  const { locale = "en" } = useLocale();
  const language =
    languages.find((language) => {
      return language.locale === locale;
    }) || languages[0];

  return { language };
};
